<template>
  <div class="flex-container relative d-flex flex-column ai-center">
    <div class="section-wrapper d-flex flex-column mg-150 ai-center">
      <div class="flex-container ai-center jc-between">
        <div class="flex-container flex-column">
          <div class="header-2 mg-50">
            데이터바우처<br />
            ONE-STOP Service
          </div>
          <div class="text-1 mg-50 opaque">
            데이터 수집 및 가공이 필요한 기업에게
            <b>최대 7천만원</b>의 지원금을
            <br />
            바우처 형태로 제공하며, 지원받으신 바우처는
            <b>데이터몬스터즈</b>를 통해 <br />
            필요한 데이터를 수집 및 가공하는 데 이용하실 수 있습니다.
          </div>
          <div class="text-lg mg-50">
            <router-link to="/datavoucher/inquiry">
              <v-btn width="300" outlined color="#1c1c1c" x-large>
                상담하기</v-btn
              ></router-link
            >
          </div>
        </div>
        <iframe
          class="yt-player"
          src="https://www.youtube.com/embed/IKY6d5fQBL0"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
      <div class="mg-150" />
      <div class="flex-container jc-center">
        <v-icon color="#1c1c1c" large>mdi-chevron-down</v-icon>
      </div>
      <div class="mg-50" />
    </div>
  </div>
</template>

<script>
// import onestop from "@/assets/onestop.jpg";

export default {
  data: () => ({
    //   onestop: onestop,
  }),
};
</script>

<style>
.yt-player {
  margin-top: 60px;
  width: 140%;
  height: 355px;
}
</style>